import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {FileSaverService} from 'ngx-filesaver';


@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient, private fileSaverService: FileSaverService) {
  }

  customUpload(formData, model) {
    return this.http.post(`files/upload-custom-form-files?uniqueId=${model.uniqueId}&childId=${model.childId}`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  uploadMultipleFiles(endpoint, formData) {
    return this.http.post(endpoint, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  customParentUpload(formData, model) {
    return this.http.post(`files/upload-custom-form-files-parent?uniqueId=${model.uniqueId}&parentId=${model.parentId}`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  uploadFile(url, file): any {
    const formData = new FormData();
    const headers = new HttpHeaders().set('content-type', 'multipart/form-data');
    formData.append('file', file);
    formData.append('uniqueId', '12345');
    console.log(formData);
    return new Promise((resolve, reject) => {
      this.http.post(`${url}`, formData).subscribe((res) => {
        resolve();
      }, (err) => reject(err));
    });
  }

  downloadFile(url: string): any {
    return new Promise ((resolve, reject) => {
      this.http.get(url, {responseType: 'blob'}).subscribe(res => resolve(res), error => reject(error));
    });
  }

  async getFile(url: string, path: string) {
    return new Promise ((resolve, reject) => {
      this.http.post(url, {path}, {responseType: 'blob'}).subscribe(res => resolve(res), error => reject(error));
    });
  }


  // onSave(url: string, fileName) {
  //   this.http.get(url, {
  //     responseType: 'blob' // This must be a Blob type
  //   }).subscribe(res => {
  //     // this.fileSaverService.save((res as any)._body, fileName);
  //     this.fileSaverService.save((res as Blob), fileName, 'application/pdf');
  //   });
  // }

  onSave(url: string, fileName: string, postBody: any) {
    this.http.post(url, postBody, {
      responseType: 'blob' // This must be a Blob type
    }).subscribe(res => {
      // this.fileSaverService.save((res as any)._body, fileName);
      this.fileSaverService.save((res as Blob), fileName, 'application/pdf');
    });
  }

  onCustomSave(endpoint: string, model: any, filename: string) {
    this.http.post(endpoint, model, {responseType: 'blob'}).subscribe(res => {
      this.fileSaverService.save((res as Blob), filename, 'application/pdf');
    });
  }

  onPostSave(url: string, postObject: any, fileName: string) {
    this.http.post(url, postObject, {
      responseType: 'blob' // This must be a Blob type
    }).subscribe(res => {
      // this.fileSaverService.save((res as any)._body, fileName);
      this.fileSaverService.save((res as Blob), fileName, 'application/pdf');
    });
  }
}
